/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import ajaxBank from "../../util/remote/ajaxBank";
import TableHeader from "../Common/TableHeader";
import Pagination from "../Common/Pagination";
import Loader from "../Common/Loader";
import AdminContext from "../../Context/AdminContext";
import Select from "react-select";

function POSDepositChargesList() {
  const [startDate, setStartDate] = useState("");

  const [endDate, setEndDate] = useState("");
  const [vendor, setVendor] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const {vendorList, getVendorList} = useContext(AdminContext);

  const [meta, setMeta] = useState([]);
  const [depositCharges, setDepositCharges] = useState([]);

  useEffect(() => {
      getVendorList();
    }, []);

  useEffect(() => {
      if (startDate || endDate || vendor) {
          searchDepositCharges();
      } else {
          getDepositCharges(page);
      }
  }, [page]);
  
  const getDepositCharges = async (currentPage) => {
      setLoading(true);
      const server_response = await ajaxBank.fetchPOSDepositChargesList(currentPage);
      setLoading(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setDepositCharges(server_response.details.data || []);
      } else {
        setDepositCharges([]);
      }
  };

  const searchDepositCharges = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      const server_response = await ajaxBank.searchPOSDepositChargesList(page,startDate,endDate,vendor);
      setLoading2(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setDepositCharges(server_response.details.data || []);
      } else {
        setDepositCharges([]);
      } 
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setCharges = (e) => {
    e.preventDefault();
    setStartDate("");
    setEndDate("");
    setVendor("");
    setPage(1);
    getDepositCharges(1);
    
  };


  return (
    <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "POS Deposit Charges List"
          subtitle="List of all the POS deposit charges sorted by the most recent"    
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={setCharges}> <i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
          </div>
        </div>
      </div>

      <form className="mg-t-20" onSubmit={searchDepositCharges}>
      <div className="row gutters-5">
        <div className="col-8-xxxl col-lg-8 col-12 form-group">
          <div className="row">
            <div className="col-lg-4 mt-2">
                <Select
                  onChange={(e) => setVendor(e.user_id)}
                  getOptionLabel={(option) => option.full_name}
                  getOptionValue={(option) => option.user_id}
                  isSearchable
                  required
                  options={Array.isArray(vendorList) ? vendorList : []}
                  value={
                      Array.isArray(vendorList) &&
                      vendorList.find((value) => value.user_id === vendor)
                  }
                />
            </div>
            <div className="col-lg-8 mt-2">
              <div className="flex-fill position-relative">
                <div className="input-group input-daterange" id="datepicker">
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="start date"
                  />
                  <span
                    className="input-group-text"
                    style={{
                      marginLeft: "-1px",
                      borderTopLeftRadius: "0",
                      borderTopRightRadius: "0",
                      borderBottomLeftRadius: "0",
                      borderBottomRightRadius: "0",
                    }}
                  >
                    to
                  </span>
                  <input
                    type="date"
                    style={{ border: "1px solid grey" }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="form-control"
                    placeholder="end date"
                  />
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <div className="col-4-xxxl col-lg-4 col-12 form-group">
          <button
            type="submit"
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue"
          >
            SEARCH
          </button>
          <button
            type="button"
            onClick={setCharges}
            className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-martini mt-2"
          >
            RESET
          </button>
        </div>
      </div>
    </form>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">Transaction Date</th>
                <th scope="col">Vendor Name</th>
                <th scope="col"> Charge Amount</th>

                </tr>
            </thead>
            <tbody>
                {depositCharges.length > 0 ? (
                    depositCharges.map((item, index) => (
                    <tr key={index}>
                        

                        <td>
                        {item.created_at?.short_date}
                        <br />
                      <small>
                      {item.created_at?.time}
                      </small>
                       
                        </td>
                        
                        <td>{item.vendor}</td>
                        <td>
                        <span className="badge bg-teal">
                          <i className="fa fa-circle text-teal fs-9px fa-fw me-5px" style={{ color: "#042954" }}></i>
                          UGX. {item.amount}
                        </span>
                        <br />
                        <small>
                          {item.description}
                        </small> 
                      </td>
                       
                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="3" style={{ textAlign: "center" }}>
                            No POS deposit charges yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
  );
}

export default POSDepositChargesList;
